import { Component, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { TarifCodeService } from 'src/app/shared/services/tarif-code.service';
import { TypeExpertiseService } from '../../shared/services/type-expertise.service';

@Component({
  selector: 'app-type-expertises',
  templateUrl: './type-expertises.component.html',
  styleUrls: ['./type-expertises.component.scss']
})
export class TypeExpertisesComponent implements OnInit {

	@ViewChild("dd", {static: false}) table;
	types: any[];
	clonedType: { [s: number]: any; } = {};
	index: number;
	lastNewId: number = -1;

	units: any[] = [
		{
			value: 1,
			label: 'Heure d\'expertise'
		},
		{
			value: 2,
			label: 'Rapport Page'
		},
		{
			value: 3,
			label: 'Heure de déplacement'
		},
		{
			value: 4,
			label: 'km'
		}
	];

	constructor(private typeExpertiseService: TypeExpertiseService,
		private tarifCodeService: TarifCodeService) { }

  	ngOnInit() {
  		this.typeExpertiseService.get().subscribe(t => this.types = t);
		  this.tarifCodeService.get().pipe(
			map(t => t.map(ta => ({value: ta.id, label: ta.name})))
		).subscribe(t => this.units = t);
  	}

  	getUnitLabel(id: number) {
  		return this.units.find(u => u.value === id).label;
  	}

    onRowEditInit(data: any, index: number) {
    	this.index = index;
       this.clonedType[data.id] = Object.assign({},{...data});
    }

    onRowEditCancel(data: any, index: number) {
        if (this.clonedType[data.id]) {
            this.types[index] = this.clonedType[data.id];
            delete this.clonedType[data.id];
        } else {

        }
    }
  	onRowEditSave(data: any) {
  		this.typeExpertiseService.save(data).subscribe(t => {
  			if (this.types.findIndex(ts => (ts.id.toString() === data.id.toString()) ) >= 0) {
  				this.types = this.types.map(ts => (ts.id.toString() === t.id.toString() ? t : ts));
  			} else {
  				console.log('not found', this.types, t.id);
  				this.types = this.types.concat(t);
  			}
	  		delete this.clonedType[data.id];
  		});
  	}

  	addType() {

  		this.lastNewId--;
  		this.types = this.types.concat({
  			id: this.lastNewId,
  			name: '',
  			unit: 1
  		});
  		this.table.editingRowKeys[this.lastNewId] = true;

  	}

}
